import { version } from "../routes/version/-version.json"
import type * as Api from "../@client/api"
import { handleResponse } from "./handle-response"

export async function post<ActionName extends keyof Api.POST>(
  url: ActionName,
  input: Api.Input[ActionName],
  requestInit?: RequestInit
) {
  const headers = new Headers(requestInit?.headers)
  headers.set("Content-Type", "application/json")
  headers.set("Client-Version", version)

  try {
    return await handleResponse<Api.Output[ActionName]>(
      await fetch(url, {
        body: JSON.stringify(input),
        method: "POST",
        ...requestInit,
        headers,
      })
    )
  } catch (error) {
    throw error
  }
}
